/* One direction per gesture: horizontal gallery drag or native vertical scrolling. */
(() => {
  const bound = new WeakSet();
  function bind(rail) {
    if (!rail || bound.has(rail)) return;
    bound.add(rail);
    let gesture, frame = 0, suppressUntil = 0;
    const preload = () => {
      if (!rail.clientWidth) return;
      const rect = rail.getBoundingClientRect();
      if (rect.bottom < -300 || rect.top > innerHeight + 300) return;
      const index = Math.round(rail.scrollLeft / (rail.clientWidth || 1));
      [...rail.children].slice(Math.max(0, index - 1), index + 3).forEach(slide => {
        const img = slide.matches('img') ? slide : slide.querySelector('img');
        if (img) img.loading = 'eager';
      });
    };
    const stop = () => { cancelAnimationFrame(frame); frame = 0; };
    const settle = target => {
      const from = rail.scrollLeft;
      const started = performance.now();
      const reduced = matchMedia('(prefers-reduced-motion:reduce)').matches;
      const tick = now => {
        const p = reduced ? 1 : Math.min(1, (now - started) / 120);
        rail.scrollLeft = from + (target - from) * (1 - Math.pow(1 - p, 3));
        if (p < 1) frame = requestAnimationFrame(tick);
        else { rail.style.scrollSnapType = ''; frame = 0; preload(); }
      };
      frame = requestAnimationFrame(tick);
    };
    rail.addEventListener('touchstart', event => {
      stop();
      rail.style.scrollSnapType = '';
      gesture = null;
      if (event.touches.length !== 1) return;
      const touch = event.touches[0];
      gesture = { x: touch.clientX, y: touch.clientY, left: rail.scrollLeft, time: performance.now(), axis: null };
      preload();
    }, { passive: true });
    rail.addEventListener('touchmove', event => {
      if (!gesture || event.touches.length !== 1) return;
      const dx = event.touches[0].clientX - gesture.x;
      const dy = event.touches[0].clientY - gesture.y;
      if (!gesture.axis && Math.max(Math.abs(dx), Math.abs(dy)) >= 4) {
        gesture.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (gesture.axis === 'x') {
          rail.style.scrollSnapType = 'none';
          rail.dataset.swiping = 'true';
        }
      }
      if (gesture.axis !== 'x') return;
      event.preventDefault();
      rail.scrollLeft = gesture.left - dx;
    }, { passive: false });
    const finish = cancelled => {
      if (!gesture) return;
      const current = gesture;
      gesture = null;
      delete rail.dataset.swiping;
      if (current.axis !== 'x') return;
      suppressUntil = Date.now() + 500;
      const width = rail.clientWidth || 1;
      const delta = rail.scrollLeft - current.left;
      const fast = Math.abs(delta) / Math.max(1, performance.now() - current.time) > .25;
      let index = Math.round(rail.scrollLeft / width);
      if (!cancelled && Math.abs(delta) > 12 && (fast || Math.abs(delta) > width * .18)) {
        index = Math.round(current.left / width) + Math.sign(delta);
      }
      const max = Math.max(0, Math.round((rail.scrollWidth - width) / width));
      settle(Math.min(max, Math.max(0, index)) * width);
    };
    rail.addEventListener('touchend', () => finish(false), { passive: true });
    rail.addEventListener('touchcancel', () => finish(true), { passive: true });
    rail.addEventListener('click', event => {
      if (Date.now() >= suppressUntil) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);
    rail.addEventListener('scroll', preload, { passive: true });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) preload();
      }, { rootMargin: '300px' });
      observer.observe(rail);
    }
    preload();
  }
  window.IllegalGallerySwipe = { bind };
  bind(document.getElementById('pdp-mobile-rail'));
})();
